import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, ComponentAsync, mouseEventHandler } from '@nu-art/thunderstorm-frontend/index';
import './PgDev_GeneralTesting.scss';
import { BadImplementationException } from '@nu-art/ts-common';
import { ModuleFE_Value, ModuleFE_Variable } from '@app/hcs-frontend';
import { valueType_EnumElement, valueType_SubRange } from '@app/hcs-shared';
const types = [valueType_EnumElement, valueType_SubRange];
class PgDev_GeneralTesting_Class extends ComponentAsync {
    async deriveStateFromProps(nextProps, state) {
        state ??= this.state ? { ...this.state } : { doNotRenderIndexes: [] };
        return state;
    }
    renderContainer = (index) => {
        if (this.state.doNotRenderIndexes.includes(index))
            return '';
        return _jsx("div", { className: `isolated-container c-${index}`, children: _jsx("div", { className: 'isolated-container-overlay', onClick: () => {
                    console.log(index);
                    this.setState({ doNotRenderIndexes: [...this.state.doNotRenderIndexes, index] });
                } }) });
    };
    clickHandler = (str) => {
        console.log(str);
    };
    getValueLabel = (value) => {
        if (value.type === valueType_EnumElement)
            return value.data.value;
        if (value.type === valueType_SubRange)
            return value.data.label;
        throw new BadImplementationException('WTF');
    };
    render() {
        return _jsxs("div", { className: 'pg-dev-general-testing', children: [_jsx("div", { children: "Some random content" }), _jsx(Button, { onClick: () => this.setState({ doNotRenderIndexes: [] }), children: "Reset overlays" }), _jsx("div", { style: { width: '100px', height: '100px', background: 'green' }, onMouseUp: e => mouseEventHandler(e, {
                        left: () => this.clickHandler('Left'),
                        middle: () => this.clickHandler('Middle'),
                        right: () => this.clickHandler('Right'),
                    }), children: "CLICK ME" }), _jsx(Button, { onClick: () => {
                        console.log(ModuleFE_Variable.cache.all().map(i => i.name).sort().join('\n'));
                    }, children: "All Variables" }), _jsx(Button, { onClick: () => {
                        // @ts-ignore
                        console.log(ModuleFE_Value.cache.filter(i => types.includes(i.type)).map(this.getValueLabel).sort().join('\n'));
                    }, children: "All Enum Values" })] });
    }
}
export const PgDev_GeneralTesting = {
    name: 'General Tests',
    key: 'general-tests',
    renderer: PgDev_GeneralTesting_Class
};
